import React, { Component } from 'react';

import PropTypes from 'prop-types';

import { Redirect } from 'react-router-dom';

import { withStyles } from '@material-ui/core/styles';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import { AppBar, Toolbar, TextField } from '@material-ui/core';
import { invitesRef, eventsRef, auth } from '../../firebase';

import moment from 'moment';

import mayBeIcon from '../../images/information.png';
import yesIcon from '../../images/checked.png';
import noIcon from '../../images/error.png';
import dollarIcon from '../../images/dollar-symbol.png';
import { AvatarIconComponent } from "../../components/icon_components";
const styles = theme => ({
    title: {
        paddingLeft: '80px',
        paddingRight: '80px',
        paddingTop: '35px',
    },
    card: {
        marginTop: "10px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#fff"
    },
    cardHover: {
        marginTop: "30px",
        width: "100%",
        margin: "25px 0",
        boxShadow: "0 1px 4px 0 rgba(0, 0, 0, 0.14)",
        borderRadius: "3px",
        color: "rgba(0, 0, 0, 0.87)",
        background: "#AAA"
    },
    cardAvatar: {
        maxWidth: "130px",
        maxHeight: "130px",
        borderRadius: "50%",
        overflow: "hidden",
        boxShadow:
            "0 10px 30px -12px rgba(0, 0, 0, 0.42), 0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2)"
    },

    textAlign: {
        textAlign: "center"
    },
    cardSubtitle: {
        color: "#999",
        fontSize: "1em",
        textTransform: "uppercase",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardTitle: {
        fontSize: "1.3em",
        marginTop: "10px",
        marginBottom: "10px"
    },
    cardDescription: {
        padding: "5px 10px",
    },
    cardActions: {
        height: "auto",
        display: "inline"
    }
});

class Invites extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            redirect: false,
            bgColor: '#FFF',
            events: [],
        };
    }

    componentDidMount() {
        invitesRef.where('email', '==', auth.currentUser.email).get()
            .then((querySnapshot) => {
                var data = [];

                querySnapshot.forEach((snapshot) => {
                    data.push(snapshot.data());
                });

                var promises = [];

                data.forEach(event => {
                    promises.push(eventsRef.doc(event.eventId).get());
                });

                Promise.all(promises).then((snapshots) => {
                    snapshots.forEach((snapshot, index) => {
                        data[index].eventName = snapshot.data().name;
                        data[index].description = snapshot.data().description;
                        data[index].date = snapshot.data().date;
                        data[index].location = snapshot.data().location;
                        data[index].images = snapshot.data().images;
                        data[index].kids = snapshot.data().kids;
                    });

                    data = data.sort((a, b) => {
                        return (moment(a.date, 'MM/DD/YYYY').isBefore(moment(b.date, 'MM/DD/YYYY')));
                    })

                    this.setState({
                        data,
                        displayData: data,
                        loading: false,
                    })
                });

            });
    }

    inviteDetail = (index) => {
        this.setState({
            select: this.state.displayData[index],
            eventRedirect: true,
        })
    }

    searchFilter = text => {
        let searchTerm = text.target.value

        const { data } = this.state;

        let displayData = [];

        data.forEach(value => {
            let name = value.eventName;


            if (name.toLocaleLowerCase().startsWith(searchTerm.toLocaleLowerCase())) {
                displayData.push(value);
            }
        });

        this.setState({ displayData });
    }

    render() {
        const { classes } = this.props;

        if (this.state.eventRedirect) {
            return (
                <Redirect to={{
                    pathname: '/invites/details/',
                    data: {
                        event: this.state.select,
                    }
                }} />
            )
        }

        if (this.state.loading) {
            return (
                <h2>Loading...</h2>
            );
        }

        var eventsSection = [];

        this.state.displayData.forEach((event, index) => {

            eventsSection[index] = (
                <Card onClick={() => this.inviteDetail(index)} style={{ paddingBottom: '20px', background: moment(event.date, 'MM/DD/YYYY').isBefore() ? '#AAA' : '#FFF' }} className={classes.card} >
                    <CardContent>
                        <Grid container xs={12} sm={12} lg={12} xl={12}>
                            <Grid key={index} item xs={10} sm={10} md={9} lg={9} xl={4}>
                                <Typography variant="title" className={classes.cardDescription}>
                                    {event.eventName}
                                </Typography>
                            </Grid>
                            <Grid key={index + 1} item xs={2} sm={2} md={3} lg={3} xl={4}>
                                <Typography component="div" className={classes.cardDescription}>
                                    {event.amount > 0 && (
                                        <img
                                            src={dollarIcon}
                                            height={30}
                                            width={30}
                                            alt="DONATED"
                                        />
                                    )}

                                    {event.rsvpStatus === 0 && (
                                        <img src={yesIcon} height={30} width={30} alt="YES" />
                                    )}
                                    {event.rsvpStatus === 1 && (
                                        <img src={noIcon} height={30} width={30} alt="NO" />
                                    )}
                                    {(event.rsvpStatus === 2 ||
                                        event.rsvpStatus === undefined) && (
                                            // <AvatarIconComponent className={classes.bigAvatar}>
                                            <img src={mayBeIcon} height={30} width={30} alt="Maybe" />
                                            // </AvatarIconComponent>
                                        )}
                                </Typography>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            );
        });

        return (
            <div style={{ padding: "40px" }}>
                {
                    this.state.data.length > 0 && (
                        <div>
                            <TextField
                                value={this.state.searchText}
                                onChange={this.searchFilter}
                                style={{
                                    paddingBottom: "30px",
                                    marginTop: "10px",
                                    width: "100%"
                                }}
                                label="Search"
                            />
                        </div>
                    )
                }
                < AppBar position="static" >
                    <Toolbar>My Invites</Toolbar>
                </AppBar >
                {this.state.data.length > 0 && eventsSection}
            </div >
        );
    }
}

Invites.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles, "#000000")(Invites);




// WEBPACK FOOTER //
// ./src/components/Invites/Invites.js